// src/helpers/getUserDocs.js

// src/helpers/getUserDocs.js
import axios from "axios";

// Prefer .env, fallback to localhost
const API_URL = process.env.REACT_APP_ID_API_URL ;
// const API_URL = process.env.REACT_APP_ID_API_URL;
if (!API_URL) {
  throw new Error("REACT_APP_ID_API_URL is not defined in .env file");
}
const buildDownloadURL = (uid, docId) =>
  `${API_URL}/api/users/${uid}/docs/${docId}/download`;

/**
 * Fetch the user's doc meta from your backend.
 */
export async function getUserDocs(uid) {
  if (!uid) throw new Error("Missing UID");

  const { data } = await axios.get(`${API_URL}/api/users/${uid}/docs/meta`);
  return data;
}

/**
 * Get decrypted blob links for this user’s ID & face
 */
export async function getUserDocsWithLinks(uid) {
  const { idDocument, headshot } = await getUserDocs(uid);

  const fetchBlobUrl = async (url) => {
    const { data } = await axios.get(url, { responseType: "blob" });
    return URL.createObjectURL(data);
  };

  const idBlobUrl = idDocument && idDocument.docId
    ? await fetchBlobUrl(buildDownloadURL(uid, idDocument.docId))
    : null;

  const headshotBlobUrl = headshot && headshot.docId
    ? await fetchBlobUrl(buildDownloadURL(uid, headshot.docId))
    : null;

  return { idDocument, headshot, idBlobUrl, headshotBlobUrl };
}
